import { CLIENT } from '../types'
import router from '@/router'
import EventBus from '@/eventbus/index.js'
import storage from '@/utils/storage'

export default {
  namespaced: true,
  state: {
    clientIdDesk4Me: '',
    clientIdFreeroom: '',
    originalDesk4MeId: null,
    originalFreeroomId: null
  },
  getters: {
    clientId (state) {
      return state.clientIdFreeroom ? state.clientIdFreeroom : state.clientIdDesk4Me
    },
    originalDesk4MeId (state) {
      return state.originalDesk4MeId
    },
    originalFreeroomId (state) {
      return state.originalFreeroomId
    },
    clientIdDesk4Me (state) {
      return state.clientIdDesk4Me
    },
    clientIdFreeroom (state) {
      return state.clientIdFreeroom
    }
  },
  mutations: {
    [CLIENT.SET_CLIENT_CONFIG] (state, item) {
      if (state.originalDesk4MeId === null && state.originalFreeroomId === null) {
        state.originalDesk4MeId = state.clientIdDesk4Me
        state.originalFreeroomId = state.clientIdFreeroom
      }
      state.clientIdDesk4Me = item.workSpaceId
      state.clientIdFreeroom = item.meetingSpaceId

    },
    [CLIENT.RESTORE_CLIENT_CONFIG] (state) {
      storage.saveToLocalStorage('clientIdDesk4Me', state.originalDesk4MeId)
      storage.saveToLocalStorage('clientIdFreeroom', state.originalFreeroomId)
      storage.removeFromLocalStorage('originalDesk4MeId')
      storage.removeFromLocalStorage('originalFreeroomId')
      state.clientIdDesk4Me = state.originalDesk4MeId
      state.clientIdFreeroom = state.originalFreeroomId
      state.originalDesk4MeId = null
      state.originalFreeroomId = null
    },
    [CLIENT.SET_CLIENT_ID] (state, ids) {
      state.clientIdDesk4Me = ids.desk4me
      state.clientIdFreeroom = ids.freeroom
    }
  },
  actions: {
    async setClient ({commit, dispatch}, item) {
      commit(CLIENT.SET_CLIENT_CONFIG, item)
      await dispatch('Global/getInitialSettings', item.meetingSpaceId ? item.meetingSpaceId : item.workspaceId, {root: true})
        router.push('/organization/admin/global/features')        
    },
    restoreClient ({commit, dispatch}) {
      EventBus.publish("restoreClient")
      commit(CLIENT.RESTORE_CLIENT_CONFIG)
      dispatch('Global/resetColor', null, {root:true})
      router.push('/organization/clients')
    },
    setClientId ({commit}, ids) {
      commit(CLIENT.SET_CLIENT_ID, ids)
    }
  }
}
